export default __webpack_public_path__ + "static/13-b9e6a8c8cdfdf2fcd221db7944f41c4d.webp";